/**<params config data>说明
 * position 控制文本框宽度和文本是否居中 left 跟 right 是一样的，top 跟 bottom 是一样的
 * titleFontSize 标题字号
 * titleColor 标题颜色
 * synopsisFontSize 副标题字号
 * synopsisColor 副标题颜色
 * desFontSize 简介字号
 * desColor 简介颜色
 * itemsColor 额外内容颜色
 * itemsbomColor 额外内容简介颜色
 */
import Image from '@/components/UI/Image';
import EFArrowRightBlueSmall from '@/components/UI/svg/Icons/EFArrowRightBlueSmall';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const item = {
    title: '576Wh Capacity',
    synopsis: 'Double up or go lightweight.',
    desc: 'RIVER Max has two 288Wh batteries. Detach the bottom one when weight takes priority or leave it on to power twice as much.',
};
const configs = {
    text: 'left',
    titleFontSize: 0.16,
    titleColor: '#03060b',
    synopsisFontSize: 0.24,
    synopsisColor: '#03060b',
    descFontSize: 0.14,
    descColor: '#222',
    itemsColor: '#03060b',
    itemsDescColor: '#666',
    itemsPhraseColor: '#919191',
    zIndex: 1,
    phraseFontSize: 0.12,
    phraseColor: '#919191',
    noticeFontSize: 0.12,
    noticeColor: '#666',
};
export default function TextBanner({ config, data = item }: any) {
    const configTypes = { ...configs, ...config };
    const { EFPic } = createEFPic(configTypes?.webpUrl);
    const { useEffect, useState, Link, useRouter } = useGlobal();
    const [isIos, setIsIos] = useState(false);
    const { locale } = useRouter();
    useEffect(() => {
        const app = navigator.userAgent;
        setIsIos(/Mac OS X/gi.test(app));
    }, []);
    return (
        <div
            className={`${css.TextBanner}`}
            style={{
                textAlign: configTypes.text === 'left' ? 'left' : 'center',
                zIndex: configTypes.zIndex,
            }}
        >
            <div key={data.title} className={`content ${isIos ? 'ipone-text' : ''}`}>
                {data.icon && (
                    <div
                        style={{
                            width: configTypes.iconWidth,
                            height: configTypes.iconHeight,
                            position: 'relative',
                        }}
                    >
                        {Array.isArray(data.icon) ? (
                            <EFPic name={data.icon} className="fullImgs" alt={data.title || data.synopsis || data.desc} />
                        ) : (
                            <Image src={data.icon} className="fullImgs" layout="fill" alt={data.title || data.synopsis || data.desc} />
                        )}
                    </div>
                )}
                {data.title && data.title !== '' && (
                    <h2
                        className="title font-family-semibold"
                        style={{
                            fontSize: `${configTypes.titleFontSize}rem`,
                            color: configTypes.titleColor,
                        }}
                    >
                        {data.title}
                    </h2>
                )}
                {data.synopsis && data.synopsis !== '' && (
                    <p
                        className={`${configTypes.gradient ? 'gradient-text' : ''} synopsis font-family-extrabold`}
                        style={{
                            fontSize: `${configTypes.synopsisFontSize}rem`,
                            color: configTypes.synopsisColor,
                            backgroundImage: configTypes.gradientColor,
                        }}
                        dangerouslySetInnerHTML={{ __html: data.synopsis }}
                    ></p>
                )}
                {data.desc && data.desc !== '' && !data.noUseHtmlAttr && (
                    <div
                        className="desc font-family-bold"
                        style={{
                            fontSize: `${configTypes.descFontSize}rem`,
                            color: configTypes.descColor,
                        }}
                        dangerouslySetInnerHTML={{ __html: data.desc }}
                    ></div>
                )}
                {data.desc && data.desc !== '' && data.noUseHtmlAttr && (
                    <div
                        className="desc font-family-bold"
                        style={{
                            fontSize: `${configTypes.descFontSize}rem`,
                            color: configTypes.descColor,
                        }}
                    >
                        {data.desc}
                    </div>
                )}
                {data.newWindLink && ['us', 'ca', 'au', 'uk', 'za'].includes(locale) && (
                    <Link href={data.newWindLink} className="new-wind__link" newWin>
                        <div className="link" style={{ fontSize: `${configTypes.descFontSize}rem` }}>
                            <span>{data.linkDesc}</span>
                            <EFArrowRightBlueSmall width="0.14rem" height="0.14rem" />
                        </div>
                    </Link>
                )}
                {data.phrase && data.phrase !== '' && (
                    <div
                        className="phrase"
                        style={{
                            fontSize: `${configTypes.phraseFontSize}rem`,
                            color: configTypes.phraseColor,
                        }}
                        dangerouslySetInnerHTML={{ __html: data.phrase }}
                    ></div>
                )}
                <div className="items" style={{ marginTop: data.arr ? '30px' : '0px' }}>
                    <ul>
                        {data.arr &&
                            data.arr.map((list: any, j: any) => (
                                <li key={list.num}>
                                    <span className="num font-family-extrabold" style={{ color: configTypes.itemsColor }}>
                                        {list.num}
                                        <span className="unit font-family-bold">{list.eum}</span>
                                    </span>
                                    <span
                                        className="desc"
                                        style={{
                                            color: configTypes.itemsDescColor,
                                            letterSpacing: isIos ? '-0.8px' : '0.3px',
                                            fontFamily: isIos ? 'var(--font-family-Medium)' : 'var(--font-family-Light)',
                                            fontWeight: isIos ? 700 : 600,
                                            marginTop: isIos ? '2px' : '1px',
                                        }}
                                    >
                                        {list.desc}
                                    </span>
                                    {list.phrase && (
                                        <span
                                            className="phrase"
                                            style={{ color: configTypes.itemsPhraseColor }}
                                            dangerouslySetInnerHTML={{ __html: list.phrase }}
                                        ></span>
                                    )}
                                </li>
                            ))}
                    </ul>
                </div>
                {data.notice && (
                    <div
                        className="notice font-family-medium"
                        style={{
                            fontSize: `${configTypes.noticeFontSize}rem`,
                            color: configTypes.noticeColor,
                        }}
                        dangerouslySetInnerHTML={{ __html: data.notice }}
                    ></div>
                )}
            </div>
        </div>
    );
}
